/**
 * Lightweight device identification — NOT invasive fingerprinting.
 * Uses basic browser characteristics to create a stable device hash.
 * Privacy-safe: no canvas, no WebGL, no audio context.
 */

const DEVICE_KEY = "anon_device_id";

async function computeHash(input) {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

function getDeviceSignals() {
  const signals = [
    navigator.userAgent || "",
    `${screen.width}x${screen.height}`,
    `${screen.colorDepth}`,
    navigator.language || "",
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    navigator.hardwareConcurrency || "",
    navigator.platform || "",
  ];
  return signals.join("|");
}

export async function getDeviceHash() {
  // Return cached if available
  const cached = localStorage.getItem(DEVICE_KEY);
  if (cached) return cached;

  try {
    const signals = getDeviceSignals();
    const hash = await computeHash(signals);
    const shortHash = hash.substring(0, 32);
    localStorage.setItem(DEVICE_KEY, shortHash);
    return shortHash;
  } catch {
    // Fallback: random ID persisted in localStorage
    const fallback = crypto.randomUUID().replace(/-/g, "").substring(0, 32);
    localStorage.setItem(DEVICE_KEY, fallback);
    return fallback;
  }
}

export function getStoredDeviceHash() {
  return localStorage.getItem(DEVICE_KEY);
}
